import { render, staticRenderFns } from "./TooLongMessageTooltip.vue?vue&type=template&id=b472824a&"
import script from "./TooLongMessageTooltip.vue?vue&type=script&lang=js&"
export * from "./TooLongMessageTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports